import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, MenuItem, Typography, IconButton } from "@material-ui/core";
import { useForm } from "../../../hooks/useForm";
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from '@material-ui/icons/Cancel';
import { startAlerta } from "../../../actions/ui/alertas";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

const useStyles = makeStyles({
  botonera: {
    padding: 25
  },
  formControl: {
    display: 'block',
    marginTop: 6,
  },
});

export const FormFormulario = ({ formData = null, handleSubmit, handleCancel }) => {
  const classes = useStyles();
  const dispatch = useDispatch()

  const { categoriasFormularios } = useSelector((state) => state.formulariosMiOspedyc);

  const hiddenFileInput = React.useRef(null);

  const [
    formValues,
    handleInputChange,
    ,
    setearValor
  ] = useForm({ ...formData, archivo: null } || { idCategoriaFormularios: "", descripcion: "", archivo: null })

  const { idCategoriaFormularios, descripcion, archivo } = formValues


  const onSubmit = (e) => {
    e.preventDefault()
    if (formData === null && archivo === null) {
      dispatch(startAlerta("Debe seleccionar un archivo para poder guardar el formulario", "warning"))
    } else {
      handleSubmit(formValues)
    }
  }

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };


  return (
    <ValidatorForm onSubmit={onSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Button
            onClick={handleClick}
            variant="outlined"
          >
            Cargar PDF
          </Button>
          <Typography style={{ marginLeft: 10 }} variant="caption">{formData?.archivo ? "" : (archivo?.name || "Aun no ha seleccionado un archivo")}</Typography>
          {
            formData?.archivo &&
            <IconButton
              component="a"
              href={`${process.env.REACT_APP_URL}/${formData?.archivo}`}
              target="_blank"
              color="primary"
              aria-label="seleccionar"
            >
              <CloudDownloadIcon />
            </IconButton>
          }
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => {
              setearValor('archivo', e.target.files[0])

              e.target.value = null;
            }}
            ref={hiddenFileInput}
            style={{ display: 'none' }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectValidator
            margin="normal"
            fullWidth
            label="Categoria"
            name="idCategoriaFormularios"
            value={idCategoriaFormularios}
            onChange={handleInputChange}
            validators={["required"]}
            errorMessages={["Seleccione una categoria"]}
          >
            {categoriasFormularios.map((item) => (
              <MenuItem
                key={item.idCategoriaFormularios}
                value={item.idCategoriaFormularios}
              >
                {item.descripcion}
              </MenuItem>
            ))}
          </SelectValidator>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextValidator
            margin="normal"
            label="Descripción"
            name="descripcion"
            value={descripcion}
            autoComplete="off"
            onChange={handleInputChange}
            fullWidth
            style={{ paddingRight: "0.5rem" }}
            validators={["required"]}
            errorMessages={["La descripción es requerida"]}
          />
        </Grid>
      </Grid>

      <Grid container className={classes.botonera} >
        <Grid item xs={12}>
          <Grid
            container
            spacing={1}
            direction="row"
            justify="flex-end"
            alignItems="center"
          >
            <Button
              variant="contained"
              color="secondary"
              size="small"
              startIcon={<CancelIcon />}
              onClick={handleCancel}

            >
              CANCELAR
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<SaveIcon />}
              type='submit'
              style={{ marginLeft: "0.5rem" }}
            >
              GUARDAR
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </ValidatorForm>
  )
}